import type { OrgEventTriggeringItem } from 'hooks/orgEvents/orgEventAutomationHooks';

export type TriggeringItemGroup = {
  key: string;
  heading: string;
  items: OrgEventTriggeringItem[];
};

function headingFor(name: string): string {
  return `Items Near [${name}]`;
}

/** Group triggering features under the asset, or area, they matched. */
export function groupTriggeringItems(
  items: OrgEventTriggeringItem[] | null | undefined
): TriggeringItemGroup[] {
  const groups = new Map<string, TriggeringItemGroup>();
  const push = (key: string, heading: string, item: OrgEventTriggeringItem) => {
    const existing = groups.get(key);
    if (existing) {
      existing.items.push(item);
      return;
    }
    groups.set(key, { key, heading, items: [item] });
  };

  for (const item of items ?? []) {
    const resourceIds = (item.resourceSetIds ?? [])
      .map((id) => id.trim())
      .filter(Boolean);
    if (resourceIds.length > 0) {
      resourceIds.forEach((id, index) => {
        const name = item.resourceNames?.[index]?.trim() || id;
        push(`resource:${id}`, headingFor(name), item);
      });
      continue;
    }
    const aorNames = (item.aorNames ?? [])
      .map((name) => name.trim())
      .filter(Boolean);
    if (aorNames.length > 0) {
      for (const name of aorNames) {
        push(`aor:${name}`, headingFor(name), item);
      }
      continue;
    }
    push('none', 'Items Near', item);
  }

  return [...groups.values()];
}
